export function distanceInHexes(x1, y1, x2, y2) {
    const ac = oddrToAxial({ col: x1, row: y1 });
    const bc = oddrToAxial({ col: x2, row: y2 });
    return (Math.abs(ac.q - bc.q) +
        Math.abs(ac.q + ac.r - bc.q - bc.r) +
        Math.abs(ac.r - bc.r)) / 2;
}
// axial → odd-r offset
function axialToOddr(a) {
    const parity = a.r & 1;
    const col = a.q + (a.r - parity) / 2;
    const row = a.r;
    return { col, row };
}
// odd-r offset → axial
function oddrToAxial(o) {
    const parity = o.row & 1;
    const q = o.col - (o.row - parity) / 2;
    const r = o.row;
    return { q, r };
}
